import { Navigate, Route, Routes } from 'react-router-dom';
import VisitStatistics from 'src/features/routes/statistics/VisitStatistics';
import CapacityStatistics from 'src/features/routes/statistics/CapacityStatistics';
import MonthlyPaymentStatistics from 'src/features/routes/statistics/MonthlyPaymentStatistics';
import GatewayStatistics from 'src/features/routes/statistics/GatewayStatistics';
import StatisticOptions from 'src/features/routes/statistics/StatisticOptions';
import PaymentStatistics from 'src/features/routes/statistics/PaymentStatistics';
import StatisticLayout from 'src/features/statistic/components/StatisticLayout';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';
import ValidationStatistics from 'src/features/routes/statistics/ValidationStatistics';
import CapacityStatsTable from 'src/features/statistic/components/CapacityStatsTable';

const StatisticRoutes = () => {
    const accessPaymentsStatistics = useHasPermissions([PERMISSION.ACCESS_PAYMENT_STATISTICS]);
    const accessOccupancyStatistics = useHasPermissions([PERMISSION.ACCESS_OCCUPANCY_STATISTICS]);
    const accessValidationStatistics = useHasPermissions([PERMISSION.ACCESS_VALIDATION_STATISTICS]);

    return (
        <Routes>
            <Route path="" element={<StatisticOptions />} />
            <Route path="" element={<StatisticLayout />}>
                {accessPaymentsStatistics && (
                    <>
                        <Route path="payment" element={<PaymentStatistics />} />
                        <Route path="monthly-payment" element={<MonthlyPaymentStatistics />} />
                    </>
                )}
                {accessOccupancyStatistics && (
                    <>
                        <Route path="visit" element={<VisitStatistics />} />
                        <Route path="capacity" element={<CapacityStatistics />} />
                        <Route path="gateway" element={<GatewayStatistics />} />
                        <Route path="capacity-stats" element={<CapacityStatsTable />} />
                    </>
                )}
                {accessValidationStatistics && <Route path="validation" element={<ValidationStatistics />} />}
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    );
};

export default StatisticRoutes;
